module.exports = __webpack_public_path__ + "img/ai.27f4316d.svg";